// Next shipment date — update the displayed restock window when the variant changes.
//
// Data sources (emitted by snippets/next-shipment-date.liquid + the theme):
//   [data-nsd-map]       JSON { variantId: "YYYY-MM-DD" }  — only variants with a date.
//   [data-variant-json]  standard Shopify product.variants JSON — used for `available`.
// Metafields aren't in [data-variant-json], which is why the date map is emitted separately.
(function () {
  if (!document.querySelector('[data-next-shipment-date]')) return;

  // Warehouse receiving pad — keep in sync with nsd_pad in snippets/next-shipment-date.liquid.
  const PAD_DAYS = 10;

  function bucketWord(day, t) {
    return day <= 10 ? t.early : (day <= 20 ? t.mid : t.late);
  }

  // Translations come from data- attributes on the container (filled by the snippet via the
  // | t filter), so the theme locale files / Translate & Adapt stay the single source of truth.
  function readStrings(container) {
    return {
      label: container.getAttribute('data-nsd-label') || 'Estimated restock',
      early: container.getAttribute('data-nsd-early') || 'Early',
      mid: container.getAttribute('data-nsd-mid') || 'Mid',
      late: container.getAttribute('data-nsd-late') || 'Late',
      soon: container.getAttribute('data-nsd-soon') || 'Soon',
      locale: container.getAttribute('data-nsd-locale') || 'en'
    };
  }

  function nsdMarkup(label, windowText, soon) {
    return '<p class="next-shipment' + (soon ? ' next-shipment--soon' : '') + '">'
      + '<span class="next-shipment__label">' + label + '</span>'
      + '<span class="next-shipment__window">' + windowText + '</span>'
      + '</p>';
  }

  function render(variantId) {
    // Re-query each call: Impulse's dynamic-variants feature swaps the section HTML on
    // change, so the container/map captured at load may be detached. Always target the
    // element currently in the DOM.
    const container = document.querySelector('[data-next-shipment-date]');
    const mapEl = document.querySelector('[data-nsd-map]');
    if (!container || !mapEl) return;

    let dateMap = {};
    try {
      dateMap = JSON.parse(mapEl.textContent.trim() || '{}');
    } catch (e) {
      return; // leave whatever the server rendered if the map is malformed
    }

    // Availability from the standard variant JSON (metafields aren't there; `available` is).
    const availById = {};
    const variantJsonEl = document.querySelector('[data-variant-json]');
    if (variantJsonEl) {
      try {
        JSON.parse(variantJsonEl.textContent).forEach(function (v) {
          availById[v.id] = v.available;
        });
      } catch (e) { /* availability defaults to unknown */ }
    }

    const id = parseInt(variantId, 10);
    const iso = dateMap[id];
    const available = availById[id];

    // No date for this variant, or it's in stock → show nothing.
    if (!iso || available === true) {
      container.innerHTML = '';
      return;
    }

    // Parse as a LOCAL date (avoid "YYYY-MM-DD" being read as UTC and shifting a day),
    // then add the receiving pad before bucketing.
    const parts = iso.split('-').map(Number);
    const nsd = new Date(parts[0], parts[1] - 1, parts[2]);
    nsd.setDate(nsd.getDate() + PAD_DAYS);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const t = readStrings(container);
    if (nsd.getTime() > today.getTime()) {
      const month = nsd.toLocaleDateString(t.locale, { month: 'long' });
      container.innerHTML = nsdMarkup(t.label, bucketWord(nsd.getDate(), t) + ' ' + month, false);
    } else {
      container.innerHTML = nsdMarkup(t.label, t.soon, true);
    }
  }

  // Initial state: take the current variant from the ?variant= URL param.
  // IMPORTANT: do NOT use [data-product-select] here — its sold-out options are
  // `disabled` with no value, so its .value points at the first IN-STOCK size and would
  // wipe the server-rendered date when the current variant is sold out. If there's no
  // ?variant= param, trust the server-rendered initial output and do nothing.
  try {
    const initialId = new URLSearchParams(window.location.search).get('variant');
    if (initialId) render(initialId);
  } catch (e) { /* no-op; server output stands */ }

  // Impulse dispatches this on the document for every variant change (incl. sold-out).
  // detail = { variant, currentlySelectedValues, value, index }
  document.addEventListener('variant:change', function (e) {
    if (e.detail && e.detail.variant && e.detail.variant.id) {
      render(e.detail.variant.id);
    }
  });
})();
